import React from 'react';
import classnames from 'classnames/bind';

import styles from './language-dropdown.scss';
let cx = classnames.bind(styles);

const LanguageDropdown = ({ locale, translations }) => {
    const locales = ['en'];

    const onChange = e => {
        const locale = e.target.value;

        window.location.href = `/${locale}`;
    }

    return (
        <div className={cx('language-dropdown', 'flex', 'column')}>
            <select onChange={onChange} value={locale}>
            {
                locales.map(l => (
                    <option key={l} value={l}>{l.toUpperCase()}</option>
                ))
            }
            </select>
        </div>
    );
};

export default LanguageDropdown;
